var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-form',{attrs:{"label-width":"100px"}},[_c('el-form-item',{attrs:{"label":"快捷短语："}},[_c('el-input',{attrs:{"value":_vm.keyword,"placeholder":"请输入快捷短语"},on:{"input":_vm.quickChange}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }